export enum NotiGroupType {
  AllUser = 'AllUser',
  MarketingAgreeUser = 'MarketingAgreeUser',
  NightMarketingAgreeUser = 'NightMarketingAgreeUser',
  NotiProfileGroup = 'NotiProfileGroup',
  ManualUser = 'ManualUser',
}

export const NotiGroupTypeString = {
  [NotiGroupType.AllUser]: '전체 회원',
  [NotiGroupType.MarketingAgreeUser]: '마케팅 동의 회원',
  [NotiGroupType.NightMarketingAgreeUser]: '야간 마케팅 동의 회원',
  [NotiGroupType.NotiProfileGroup]: '커스텀 그룹',
  [NotiGroupType.ManualUser]: '프로필 ID 지정 회원',
};

export enum NotiExtraDomainType {
  Content = 'Content',
  Episode = 'Episode',
  Reply = 'Reply',
  ReplyLike = 'ReplyLike',
  ReReply = 'ReReply',
  ReReplyLike = 'ReReplyLike',
  RidiPointCoupon = 'RidiPointCoupon',
  DirittoMessage = 'DirittoMessage',
  Dormant = 'Dormant',
  AttendanceCheck = 'AttendanceCheck',
  ChatMessage = 'ChatMessage',
}

export const NotiExtraDomainTypeString = {
  [NotiExtraDomainType.Content]: 'Content',
  [NotiExtraDomainType.Episode]: 'Episode',
  [NotiExtraDomainType.Reply]: 'Reply',
  [NotiExtraDomainType.ReplyLike]: 'ReplyLike',
  [NotiExtraDomainType.ReReply]: 'ReReply',
  [NotiExtraDomainType.ReReplyLike]: 'ReReplyLike',
  [NotiExtraDomainType.RidiPointCoupon]: 'RidiPointCoupon',
  [NotiExtraDomainType.DirittoMessage]: 'DirittoMessage',
  [NotiExtraDomainType.Dormant]: 'Dormant',
  [NotiExtraDomainType.AttendanceCheck]: 'AttendanceCheck',
  [NotiExtraDomainType.ChatMessage]: 'ChatMessage',
};

export const NotiExtraDomainTypes = [NotiExtraDomainType.DirittoMessage];

export const NotiExtraDomainTypeOptions = NotiExtraDomainTypes.map(it => ({
  label: NotiExtraDomainTypeString[it],
  id: it,
  value: it,
}));

export enum NotiType {
  Personal = 'Personal',
  Group = 'Group',
}

export enum NotiMethod {
  Push = 'Push',
  Inbox = 'Inbox',
  Email = 'Email',
}

export const NotiMethodString = {
  [NotiMethod.Push]: '푸시',
  [NotiMethod.Inbox]: '알림센터',
  [NotiMethod.Email]: '이메일',
};

export const fff = [NotiMethod.Inbox, NotiMethod.Push];
export const NotiMethodOptions = fff.map(it => ({
  label: NotiMethodString[it],
  id: it,
  value: it,
}));

export enum NotiStatus {
  Ready = 'Ready',
  Sent = 'Sent',
  Fail = 'Fail',
  FailNotExistSsoEmail = 'FailNotExistSsoEmail',
  FailNotExistPushToken = 'FailNotExistPushToken',
  FailNotExistEmailData = 'FailNotExistEmailData',
  FailNotExistUserId = 'FailNotExistUserId',
  FailNotAgreeMarketing = 'FailNotAgreeMarketing',
  FailNotAgreeNightMarketing = 'FailNotAgreeNightMarketing',
  FailNotRegisteredToken = 'FailNotRegisteredToken',
  FailNotExistDevice = 'FailNotExistDevice',
}

export type NotiFailStatus =
  | NotiStatus.Fail
  | NotiStatus.FailNotExistPushToken
  | NotiStatus.FailNotExistSsoEmail
  | NotiStatus.FailNotExistEmailData
  | NotiStatus.FailNotExistUserId
  | NotiStatus.FailNotAgreeMarketing
  | NotiStatus.FailNotAgreeNightMarketing
  | NotiStatus.FailNotRegisteredToken
  | NotiStatus.FailNotExistDevice;

export enum InboxNotiType {
  All = 'All',
  Update = 'Update',
  Reply = 'Reply',
  Event = 'Event',
}

export const InboxNotiTypes = [InboxNotiType.All, InboxNotiType.Update, InboxNotiType.Reply, InboxNotiType.Event];

export const InboxNotiTypeText = {
  [InboxNotiType.All]: '전체',
  [InboxNotiType.Update]: '업데이트',
  [InboxNotiType.Reply]: '내 소식',
  [InboxNotiType.Event]: '이벤트',
} satisfies Record<InboxNotiType, string>;
